import chroma from 'chroma-js'

export const HEATMAP_METRICS = [
  {
    id: 'sell_through',
    label: 'Sell-through',
    description: 'Which sections consistently sell first',
    higherIsBetter: true,
  },
  {
    id: 'heat_score',
    label: 'Demand heat',
    description: 'Event sell-through intensity by seat',
    higherIsBetter: true,
  },
  {
    id: 'days_to_sell',
    label: 'Days to sell',
    description: 'How far before show time tickets move (cooler = slower)',
    higherIsBetter: false,
  },
  {
    id: 'gross_revenue',
    label: 'Gross revenue',
    description: 'Premium inventory performance',
    higherIsBetter: true,
  },
  {
    id: 'avg_price',
    label: 'Avg ticket price',
    description: 'Pricing tier performance across the venue',
    higherIsBetter: true,
  },
  {
    id: 'attendance',
    label: 'Scan rate',
    description: 'Show-up rate after purchase',
    higherIsBetter: true,
  },
  {
    id: 'comp_ratio',
    label: 'Comp & promo load',
    description: 'Impact of comps and promotional inventory',
    higherIsBetter: false,
  },
]

const METRIC_VALUE_KEYS = {
  sell_through: 'sellThroughPercentage',
  heat_score: 'heatScore',
  days_to_sell: 'averageDaysBeforeEvent',
  attendance: 'attendancePercentage',
  gross_revenue: 'totalGrossRevenue',
  avg_price: 'averageTicketPrice',
  comp_ratio: 'compRatio',
}

export function buildSeatKey(section, row, seat) {
  return [section, row, seat]
    .map((v) => (v == null || v === '' ? null : String(v)))
    .filter((v) => v != null)
    .join('-')
}

export function getMetricValue(analytics, metricId) {
  if (!analytics) return null
  const key = METRIC_VALUE_KEYS[metricId]
  if (!key) return null
  const value = Number(analytics[key])
  return Number.isFinite(value) ? value : null
}

export function getHeatColor(value, min, max, higherIsBetter = true) {
  const NO_DATA_COLOR = '#d1d5db'
  if (value == null || !Number.isFinite(value)) return NO_DATA_COLOR
  if (min === max) {
    return higherIsBetter ? '#22c55e' : '#3b82f6'
  }

  let t = (value - min) / (max - min)
  if (!higherIsBetter) t = 1 - t
  t = Math.max(0, Math.min(1, t))

  return chroma.scale(['#3b82f6', '#eab308', '#ef4444']).mode('lab')(t).hex()
}

export function formatMetricValue(metricId, value) {
  if (value == null || !Number.isFinite(value)) return '—'
  switch (metricId) {
    case 'heat_score':
      return `${Math.round(value <= 1 ? value * 100 : value)}%`
    case 'sell_through':
    case 'attendance':
      return `${Math.round(value)}%`
    case 'days_to_sell':
      return `${Math.round(value)}d`
    case 'gross_revenue':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      }).format(value)
    case 'avg_price':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value)
    case 'comp_ratio':
      return `${Math.round(value * 100)}%`
    default:
      return String(value)
  }
}
